import $$ from 'cmn-utils';

//查询公告列表
export async function qryAnnouncementList(payload) {
	return $$.post('/message/qryAnnouncementList', payload);
}

//新增公告
export async function addAnnouncement(payload) {
	return $$.post('/message/addAnnouncement', payload);
}

//删除公告
export async function delAnnouncement(payload) {
	return $$.post('/message/delAnnouncement', payload);
}

//新增公告
export async function updateAnnouncement(payload) {
	return $$.post('/message/updateAnnouncement', payload);
}

//更新公告状态
export async function updateAnnouncementStatus(payload) {
	return $$.post('/message/updateAnnouncementStatus', payload);
}











// WEBPACK FOOTER //
// ./src/routes/NavBar/SystemNotice/service/index.js